import { render, staticRenderFns } from "./SchoolAdministrator.vue?vue&type=template&id=b2d555ac&scoped=true"
import script from "./SchoolAdministrator.vue?vue&type=script&lang=js"
export * from "./SchoolAdministrator.vue?vue&type=script&lang=js"
import style0 from "./SchoolAdministrator.vue?vue&type=style&index=0&id=b2d555ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d555ac",
  null
  
)

export default component.exports